import React from 'react';
import style from '../css/modalButton.css';
import {getText} from "../../../helpers/localization";


export function ModalButton({ title,customStyle, onClick, store }) {
    let buttonStyle = '';
    if(customStyle === "disableOptInButton"){
        buttonStyle=style.disabledButton;
    }
    return (
        <div className={style.viewOffers} onClick={onClick}>
            <button className={`${style.viewOffersButton} ${buttonStyle}`} >
                <span className={`${style.viewOffersButtonText} ${buttonStyle}`} >{getText(title,store)}</span> </button>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/modalButton.js